import {
  ArrowsClockwise,
  GraduationCap,
  Image,
  Lightbulb,
  Lightning,
  Link,
  MagicWand,
  PaintBrush,
  RocketLaunch,
  TextB,
  TextItalic,
  VideoCamera,
} from '@phosphor-icons/react';
import { FaWeixin } from 'react-icons/fa';
import { Flex, Space } from 'antd';

const VideoTeach = () => {
  return (
    <div className="carousel-slide carousel-two-slide">
      <Flex className="container carousel-content-wrapper" align="center">
        <div className="carousel-content">
          <div className="carousel-badge">
            <div className="carousel-badge-pulse"></div>
            <span>一站式内容创作与分发引擎</span>
          </div>
          <h2 className="carousel-title">
            <span className="carousel-title-main">全媒体内容</span>
            <span className="carousel-title-highlight">运营助手</span>
          </h2>
          {/* <p className="carousel-description">从入门到精通，一站式AI智能体创建与管理学习平台</p> */}
          <div className="carousel-features">
            <div className="carousel-feature">
              <div className="carousel-feature-icon">
                <div className="carousel-icon-pulse"></div>
                <RocketLaunch weight="fill" />
              </div>
              <Flex className="carousel-feature-content" vertical>
                <strong className="carousel-feature-title">公众号运营插件</strong>
                <span className="carousel-feature-desc">AI文章智能生成与优化</span>
              </Flex>
            </div>
            <div className="carousel-feature">
              <div className="carousel-feature-icon">
                <div className="carousel-icon-pulse"></div>
                <Lightbulb weight="fill" />
              </div>
              <div className="carousel-feature-text">一键推送至微信公众平台</div>
            </div>
            <div className="carousel-feature">
              <div className="carousel-feature-icon">
                <div className="carousel-icon-pulse"></div>
                <GraduationCap weight="fill" />
              </div>
              <div className="carousel-feature-text">多资源嵌入（图文/视频/小程序）</div>
            </div>
          </div>
          <Space className="carousel-cta mt-0" size="large">
            <Space className="carousel-btn">
              <PaintBrush size={32} weight="fill" />
              <span>图文编辑工具</span>
            </Space>
            <Space className="carousel-btn">
              <ArrowsClockwise size={32} weight="bold" />
              <span>一键同步多平台</span>
            </Space>
          </Space>
        </div>
        <div className="carousel-visual relative carousel-right">
          {/* <div className="carousel-video-preview">
              <div className="carousel-video-overlay">
                <div className="carousel-play-button">
                  <PlayCircle size={40} weight="fill" />
                </div>
              </div>
              <div className="carousel-video-card">
                <div className="carousel-card-header">
                  <span className="carousel-card-tag">热门课程</span>
                  <h4 className="carousel-card-title">AI智能体工作流搭建从零到一</h4>
                </div>
                <div className="carousel-card-footer">
                  <div className="carousel-stats">
                    <div className="carousel-stat">
                      <UsersThree size={24} className="carousel-stat-icon" weight="fill" />
                      <span>8.5k+ 学员</span>
                    </div>
                    <div className="carousel-stat">
                      <Clock size={24} className="carousel-stat-icon" weight="fill" />
                      <span>25分钟</span>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          <div className="carousel-floating-items">
            <div className="carousel-float-item carousel-float-item-1">
              <div className="carousel-float-icon">
                <MagicWand size={24} weight="fill" />
              </div>
              <div className="carousel-float-text">图片编辑工具</div>
            </div>
            <div className="carousel-float-item carousel-float-item-2">
              <div className="carousel-float-icon">
                <Lightning size={24} weight="fill" />
              </div>
              <div className="carousel-float-text">高效批处理</div>
            </div>
          </div>
          <div className="carousel-wechat-tools">
            <div className="carousel-wechat-logo">
              <FaWeixin />
            </div>
            <div className="carousel-editor-toolbar">
              <div className="carousel-tool-btn">
                <TextB weight="bold" />
              </div>
              <div className="carousel-tool-btn">
                <TextItalic weight="bold" />
                <i className="fas fa-italic"></i>
              </div>
              <div className="carousel-tool-btn">
                <Link weight="bold" />
                <i className="fas fa-link"></i>
              </div>
              <div className="carousel-tool-btn">
                <Image weight="fill" />
                <i className="fas fa-image"></i>
              </div>
              <div className="carousel-tool-btn">
                <VideoCamera weight="fill" />
              </div>
            </div>
          </div>
        </div>
      </Flex>
      <div className="carousel-decorations">
        <div className="carousel-decoration carousel-decoration-1"></div>
        <div className="carousel-decoration carousel-decoration-2"></div>
        <div className="carousel-decoration carousel-decoration-3"></div>
        <div className="carousel-grid-lines"></div>
        <div className="carousel-particles">
          <div className="carousel-particle carousel-particle-1"></div>
          <div className="carousel-particle carousel-particle-2"></div>
          <div className="carousel-particle carousel-particle-3"></div>
          <div className="carousel-particle carousel-particle-4"></div>
          <div className="carousel-particle carousel-particle-5"></div>
          <div className="carousel-particle carousel-particle-6"></div>
          <div className="carousel-particle carousel-particle-7"></div>
          <div className="carousel-particle carousel-particle-8"></div>
        </div>
      </div>
    </div>
  );
};

export default VideoTeach;
